import * as React from 'react';

import * as styles from './QuickLinks.css';
import { QuickLinksList } from './components/QuickLinksList';
import { QuickLinksTabsComponent } from './components/QuickLinksTabs';
import { QuickLinksSuburbanTrap } from './components/QuickLinksSuburbanTrap';
import { AvgPriceInformer } from '../AvgPriceInformer';
import { getGroupedLinks } from '../../containers/QuickLinksContainer/utils/groupLinks';
import { IAvgPriceInformer } from '../../../types/offersData';
import { IOldQuickLinks, IQuickLinksTab } from '../../../types/quickLinks';

export interface IQuickLinksStateProps {
  tabs: IQuickLinksTab[];
  countrysideBlackFridayLink?: string;
  isSuburbanListing: boolean;
  avgPriceInformer: IAvgPriceInformer | null;
  isRent: boolean;
  oldQuickLinks: IOldQuickLinks | null;
}

export interface IQuickLinksProps extends IQuickLinksStateProps {
  banner?: React.ReactNode;
}

export const QuickLinks = ({
  isSuburbanListing,
  tabs,
  countrysideBlackFridayLink,
  banner,
  avgPriceInformer,
  isRent,
  oldQuickLinks,
}: IQuickLinksProps) => {
  const hasQuickLinks = tabs.length > 0;
  const oldLinkGroups = !hasQuickLinks && oldQuickLinks ? getGroupedLinks(oldQuickLinks.links) : [];

  return (
    <div className={styles['wrapper']} data-testid="quick-links">
      {avgPriceInformer && <AvgPriceInformer avgPriceInformer={avgPriceInformer} isRent={isRent} />}
      {hasQuickLinks && <QuickLinksTabsComponent tabs={tabs} />}
      {!hasQuickLinks && oldLinkGroups.length > 0 && <QuickLinksList linkGroups={oldLinkGroups} />}
      {isSuburbanListing && (
        <QuickLinksSuburbanTrap countrysideBlackFridayLink={countrysideBlackFridayLink} banner={banner} />
      )}
    </div>
  );
};
